import { ADD_SONG_TO_PLAYLIST } from "../actions/playList";
import { CREATE_PLAYLIST, INIT_PLAY_LIST } from "../actions/playList";
const initialState = {};

export default function (state = initialState, action) {
  if (action.type === INIT_PLAY_LIST) {
    return action.payload;
  }
  if (action.type === CREATE_PLAYLIST) {
    if (state[action.payload.playListName] === undefined) {
      let newState = { ...state };
      newState[action.payload.playListName] = { songs: [] };
      return newState;
    }
  } else if (action.type === ADD_SONG_TO_PLAYLIST) {
    const newState = { ...state };
    newState[action.payload.playListKey]["songs"]["push"](action.payload.song);
    console.log("add to playlist", newState);
    return newState;
  }
  return state;
}
